
					import "data:text/css,button%20%7B%0A%20%20border:%20unset;%0A%20%20background-color:%20unset;%0A%7D%0Abutton:focus%20%7B%0A%20%20outline:%20none;%0A%7D%0A%0A.sass-pfln%20%7B%0A%20%20display:%20flex;%0A%20%20flex-direction:%20row;%0A%20%20justify-content:%20center;%0A%20%20align-items:%20center;%0A%20%20min-height:%20100vh;%0A%20%20gap:%2016px;%0A%7D%0A%0A.sass-tp53%20%7B%0A%20%20padding:%2016px%2032px;%0A%20%20font-size:%2018px;%0A%20%20background-color:%20#f2f2f2;%0A%20%20border-radius:%208px;%0A%20%20box-shadow:%200%200%200%201px%20rgba(0,%200,%200,%200.1),%200%202px%208px%20-4px%20rgba(0,%200,%200,%200.25);%0A%20%20transition:%20200ms%20cubic-bezier(0,%200,%200.2,%201);%0A%7D%0A.sass-tp53:hover%20%7B%0A%20%20background-color:%20whitesmoke;%0A%7D%0A.sass-tp53:focus%20%7B%0A%20%20box-shadow:%200%200%200%200.5px%20rgba(0,%20128,%20255,%200.5),%200%200%200%204px%20rgba(0,%20128,%20255,%200.25);%0A%7D"
					
			function sass(raw) {
				return {
					"\n\tdisplay: flex;\n\tflex-direction: row;\n\tjustify-content: center;\n\talign-items: center;\n\tmin-height: 100vh;\n\n\tgap: 16px;\n": (() => {
						const comp = function ({ className, ...props }) {
							return React.createElement("div", {
								className: ["sass-pfln", className]
									.filter(Boolean)
									.join(" "),
								...props
							})
						}
						Object.assign(comp, {
							tagName: "div",
							className: "sass-pfln",
						})
						return comp
					})(),"\n\t$gray: hsl(0, 0%, 95%);\n\n\tpadding: 16px 32px;\n\tfont-size: 18px;\n\tbackground-color: $gray;\n\tborder-radius: 8px;\n\tbox-shadow: $shadow;\n\n\t&:hover {\n\t\tbackground-color: color.adjust($gray, $lightness: 1.125%);\n\t}\n\t&:focus {\n\t\tbox-shadow: $focus-shadow;\n\t}\n\n\ttransition: 200ms cubic-bezier(0, 0, 0.2, 1);\n": (() => {
						const comp = function ({ className, ...props }) {
							return React.createElement("button", {
								className: ["sass-tp53", className]
									.filter(Boolean)
									.join(" "),
								...props
							})
						}
						Object.assign(comp, {
							tagName: "button",
							className: "sass-tp53",
						})
						return comp
					})(),
				}[raw]
			}

			export default {
				// No-op
				global(raw) {},

				a(raw)              { return sass(raw) },
				abbr(raw)           { return sass(raw) },
				address(raw)        { return sass(raw) },
				area(raw)           { return sass(raw) },
				article(raw)        { return sass(raw) },
				aside(raw)          { return sass(raw) },
				audio(raw)          { return sass(raw) },
				b(raw)              { return sass(raw) },
				base(raw)           { return sass(raw) },
				bdi(raw)            { return sass(raw) },
				bdo(raw)            { return sass(raw) },
				big(raw)            { return sass(raw) },
				blockquote(raw)     { return sass(raw) },
				body(raw)           { return sass(raw) },
				br(raw)             { return sass(raw) },
				button(raw)         { return sass(raw) },
				canvas(raw)         { return sass(raw) },
				caption(raw)        { return sass(raw) },
				cite(raw)           { return sass(raw) },
				code(raw)           { return sass(raw) },
				col(raw)            { return sass(raw) },
				colgroup(raw)       { return sass(raw) },
				data(raw)           { return sass(raw) },
				datalist(raw)       { return sass(raw) },
				dd(raw)             { return sass(raw) },
				del(raw)            { return sass(raw) },
				details(raw)        { return sass(raw) },
				dfn(raw)            { return sass(raw) },
				dialog(raw)         { return sass(raw) },
				div(raw)            { return sass(raw) },
				dl(raw)             { return sass(raw) },
				dt(raw)             { return sass(raw) },
				em(raw)             { return sass(raw) },
				embed(raw)          { return sass(raw) },
				fieldset(raw)       { return sass(raw) },
				figcaption(raw)     { return sass(raw) },
				figure(raw)         { return sass(raw) },
				footer(raw)         { return sass(raw) },
				form(raw)           { return sass(raw) },
				h1(raw)             { return sass(raw) },
				h2(raw)             { return sass(raw) },
				h3(raw)             { return sass(raw) },
				h4(raw)             { return sass(raw) },
				h5(raw)             { return sass(raw) },
				h6(raw)             { return sass(raw) },
				head(raw)           { return sass(raw) },
				header(raw)         { return sass(raw) },
				hgroup(raw)         { return sass(raw) },
				hr(raw)             { return sass(raw) },
				html(raw)           { return sass(raw) },
				i(raw)              { return sass(raw) },
				iframe(raw)         { return sass(raw) },
				img(raw)            { return sass(raw) },
				input(raw)          { return sass(raw) },
				ins(raw)            { return sass(raw) },
				kbd(raw)            { return sass(raw) },
				keygen(raw)         { return sass(raw) },
				label(raw)          { return sass(raw) },
				legend(raw)         { return sass(raw) },
				li(raw)             { return sass(raw) },
				link(raw)           { return sass(raw) },
				main(raw)           { return sass(raw) },
				map(raw)            { return sass(raw) },
				mark(raw)           { return sass(raw) },
				marquee(raw)        { return sass(raw) },
				menu(raw)           { return sass(raw) },
				menuitem(raw)       { return sass(raw) },
				meta(raw)           { return sass(raw) },
				meter(raw)          { return sass(raw) },
				nav(raw)            { return sass(raw) },
				noscript(raw)       { return sass(raw) },
				object(raw)         { return sass(raw) },
				ol(raw)             { return sass(raw) },
				optgroup(raw)       { return sass(raw) },
				option(raw)         { return sass(raw) },
				output(raw)         { return sass(raw) },
				p(raw)              { return sass(raw) },
				param(raw)          { return sass(raw) },
				picture(raw)        { return sass(raw) },
				pre(raw)            { return sass(raw) },
				progress(raw)       { return sass(raw) },
				q(raw)              { return sass(raw) },
				rp(raw)             { return sass(raw) },
				rt(raw)             { return sass(raw) },
				ruby(raw)           { return sass(raw) },
				s(raw)              { return sass(raw) },
				samp(raw)           { return sass(raw) },
				script(raw)         { return sass(raw) },
				section(raw)        { return sass(raw) },
				select(raw)         { return sass(raw) },
				small(raw)          { return sass(raw) },
				source(raw)         { return sass(raw) },
				span(raw)           { return sass(raw) },
				strong(raw)         { return sass(raw) },
				style(raw)          { return sass(raw) },
				sub(raw)            { return sass(raw) },
				summary(raw)        { return sass(raw) },
				sup(raw)            { return sass(raw) },
				table(raw)          { return sass(raw) },
				tbody(raw)          { return sass(raw) },
				td(raw)             { return sass(raw) },
				textarea(raw)       { return sass(raw) },
				tfoot(raw)          { return sass(raw) },
				th(raw)             { return sass(raw) },
				thead(raw)          { return sass(raw) },
				time(raw)           { return sass(raw) },
				title(raw)          { return sass(raw) },
				tr(raw)             { return sass(raw) },
				track(raw)          { return sass(raw) },
				u(raw)              { return sass(raw) },
				ul(raw)             { return sass(raw) },
				var(raw)            { return sass(raw) },
				video(raw)          { return sass(raw) },
				wbr(raw)            { return sass(raw) },

				// SVG
				circle(raw)         { return sass(raw) },
				clipPath(raw)       { return sass(raw) },
				defs(raw)           { return sass(raw) },
				ellipse(raw)        { return sass(raw) },
				foreignObject(raw)  { return sass(raw) },
				g(raw)              { return sass(raw) },
				image(raw)          { return sass(raw) },
				line(raw)           { return sass(raw) },
				linearGradient(raw) { return sass(raw) },
				marker(raw)         { return sass(raw) },
				mask(raw)           { return sass(raw) },
				path(raw)           { return sass(raw) },
				pattern(raw)        { return sass(raw) },
				polygon(raw)        { return sass(raw) },
				polyline(raw)       { return sass(raw) },
				radialGradient(raw) { return sass(raw) },
				rect(raw)           { return sass(raw) },
				stop(raw)           { return sass(raw) },
				svg(raw)            { return sass(raw) },
				text(raw)           { return sass(raw) },
				tspan(raw)          { return sass(raw) },
			}
		
				